import { render, staticRenderFns } from "./PedidosForm.vue?vue&type=template&id=a505eba4&scoped=true&"
import script from "./PedidosForm.vue?vue&type=script&lang=js&"
export * from "./PedidosForm.vue?vue&type=script&lang=js&"
import style0 from "./PedidosForm.vue?vue&type=style&index=0&id=a505eba4&scoped=true&lang=css&"
import style1 from "./PedidosForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a505eba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VIcon,VProgressCircular,VRow,VTooltip})
